import DraggableStepCard from '../../DraggableStepCard';

export const content = ({ step }) => step.description;

export const getDescription = ({
  step: { details },
  providerModelLookup,
  t,
}) => {
  return t('Prompt {{ modelName }} with ‘{{ prompt }}’', {
    modelName: providerModelLookup?.[details.modelName] ?? details.modelName,
    prompt: details.prompt,
  });
};

export default function CallLLMCard({ step, ...others }) {
  return <DraggableStepCard {...others}>{content({ step })}</DraggableStepCard>;
}
